import { ReducersTypes } from "constants/ReducersTypes";

const initialState = {
  list: [],
  totalCount: 0,
  isFetching: false,
  filters: { page: 1 },
};

const creditOpenItems = (state = initialState, action) => {
  switch (action.type) {
    case ReducersTypes.CREDIT_OPEN_ITEMS:
      return { ...state, ...action.payload };
    case ReducersTypes.RESET_CREDIT_OPEN_ITEMS:
      return { ...initialState };
    default:
      return state;
  }
};

export default creditOpenItems;
